<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="environment-bar">
	<div class="environment-name" *ngIf="isNotProduction$ | async">
		{{ environmentName$ | async }}
	</div>
	<div class="environment-version" *ngIf="buildNumber != null">v{{ buildNumber }}</div>
</div>
